import { defaultSearchTermSelector } from '../store/selectors/saytSelector';
import { setDefaultSearchTerm, setSearchInput } from '../store/slices/sayt';
import { useAppDispatch, useAppSelector } from '../store/store';

const useSetSearchTerm = () => {
  const dispatch = useAppDispatch();
  const defaultSearchTerm = useAppSelector(defaultSearchTermSelector);

  const setSearchTerm = (value: string) => {
    dispatch(setSearchInput(value));

    if (defaultSearchTerm) {
      dispatch(setDefaultSearchTerm(null));
    }
  };

  return [setSearchTerm];
};

export default useSetSearchTerm;
